/* eslint-disable no-restricted-imports */
import { useEffect, useState } from 'react';
import {
    DirectCampaignUI,
    DirectStrategyType,
    DirectPayForType,
    DirectBudgetType,
    DirectSpendLimitType,
} from '../../../../data-layer/direct/types';
import {
    BudgetType,
    PayForType,
    SpendLimitType,
    StrategyType,
} from '../../../../ui/business/ContentPromotionBudget/parts/ContentPromotionBudgetStrategy/types';
import { DropdownOption } from '../../../../ui/business/ContentPromotionBudget/parts/ContentPromotionDropdown/types';
import { getSpendLimitOptions, type SpendLimitOptionsProps } from '../utils/getSpendLimitOptions';

export const usePromotionStrategy = (
    company?: DirectCampaignUI,
    options?: SpendLimitOptionsProps,
) => {
    const [strategyType, setStrategyType] = useState<StrategyType>(
        company?.strategyType || DirectStrategyType.MAX_CONVERSIONS,
    );
    const [payFor, setPayFor] = useState<PayForType>(company?.payFor || DirectPayForType.CLICKS);
    const [budgetType, setBudgetType] = useState<BudgetType>(
        company?.budgetType || DirectBudgetType.WEEKLY_LIMIT,
    );
    const [spendLimitType, setSpendLimitType] = useState<SpendLimitType>(
        company?.spendLimitType || DirectSpendLimitType.AVERAGE_CPC,
    );
    const [spendLimitAmount, setSpendLimitAmount] = useState<number | undefined>(
        company?.spendLimitAmount,
    );

    const [spendLimitOptions, setSpendLimitOptions] = useState<DropdownOption[]>(
        getSpendLimitOptions(strategyType, payFor, options),
    );

    const onChangeStrategyType = (value: StrategyType) => {
        setStrategyType(value);

        if (value === DirectStrategyType.MAX_CLICKS) {
            setPayFor(DirectPayForType.CLICKS);
        }
    };

    const onChangePayFor = (value: PayForType) => {
        setPayFor(value);
    };

    const onChangeBudgetType = (value: BudgetType) => {
        setBudgetType(value);
    };

    const onChangeSpendLimitType = (value: SpendLimitType) => {
        setSpendLimitType(value);
    };

    const onChangeSpendLimitAmount = (value: string) => {
        setSpendLimitAmount(Number(value));
    };

    useEffect(() => {
        const newSpendLimitOptions = getSpendLimitOptions(strategyType, payFor, options);
        setSpendLimitOptions(newSpendLimitOptions);
        setSpendLimitType(newSpendLimitOptions[0].value as DirectSpendLimitType);
        // options проставляется из эксп флагов, можно оторвать при отрыве флагов enable_promotion_weekly_limit и enable_promotion_crr
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [strategyType, payFor]);

    useEffect(() => {
        setSpendLimitAmount(undefined);
    }, [spendLimitType]);

    useEffect(() => {
        if (company) {
            setStrategyType(company.strategyType || DirectStrategyType.MAX_CONVERSIONS);
            setPayFor(company.payFor || DirectPayForType.CLICKS);
            setBudgetType(company.budgetType || DirectBudgetType.WEEKLY_LIMIT);
            setSpendLimitType(company.spendLimitType || DirectSpendLimitType.AVERAGE_CPC);
            setSpendLimitAmount(company.spendLimitAmount);
        }
    }, [company]);

    return {
        strategyType,
        payFor,
        budgetType,
        spendLimitType,
        spendLimitAmount,
        spendLimitOptions,
        onChangeStrategyType,
        onChangePayFor,
        onChangeBudgetType,
        onChangeSpendLimitType,
        onChangeSpendLimitAmount,
    };
};
